import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "@/components/primitives";
import { WHY_US } from "@/data/content";

export default function WhyUs() {
    return (
        <section className="border-t border-border bg-secondary/40 py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <Reveal>
                    <Eyebrow>Why Companies Work With Us</Eyebrow>
                </Reveal>
                <Reveal delay={0.05}>
                    <h2 className="mt-5 max-w-2xl text-balance text-4xl font-bold leading-[1.1] tracking-tight md:text-5xl">
                        A partner, not a platform
                    </h2>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
                    {WHY_US.map((c, i) => {
                        const Icon = c.icon;
                        return (
                            <Reveal key={c.title} delay={i * 0.08}>
                                <motion.div
                                    whileHover={{ y: -6 }}
                                    transition={{
                                        duration: 0.4,
                                        ease: [0.16, 1, 0.3, 1],
                                    }}
                                    className="group relative flex h-full min-h-[320px] flex-col justify-between overflow-hidden rounded-3xl border border-white/10 bg-brand p-9 text-white"
                                >
                                    <div
                                        aria-hidden
                                        className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-white/15 blur-3xl transition-opacity duration-500 group-hover:opacity-90"
                                    />
                                    <div className="relative grid h-12 w-12 place-items-center rounded-xl border border-white/15 bg-white/5 text-white">
                                        <Icon className="h-5 w-5" strokeWidth={1.5} />
                                    </div>
                                    <div className="relative">
                                        <h3 className="text-2xl font-semibold tracking-tight">
                                            {c.title}
                                        </h3>
                                        <p className="mt-3 text-[15px] leading-relaxed text-white/70">
                                            {c.body}
                                        </p>
                                    </div>
                                </motion.div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
